// extracted by mini-css-extract-plugin
export default {"button":"addButton_button__mq680"};